/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CoverFull({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m3.5 5.202 1.798-1.799M3.5 5.202 5.298 7M3.5 5.202h4.8m4.2 0-1.798-1.799M12.5 5.202 10.702 7M12.5 5.202H7.7" /><rect width={14} height={8.25} x={1} y={1} stroke="currentColor" strokeWidth={1.2} rx={1.5} /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M4 12.125h8M4 14.5h5" /></svg>;
}
;